import axios from "axios";
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "jms_employee_token";

export const employeeApi = axios.create({ baseURL: API });
employeeApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const EmployeeAuthContext = createContext(null);

export function EmployeeAuthProvider({ children }) {
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setEmployee(null); setLoading(false); return; }
    try {
      const { data } = await employeeApi.get("/employee-portal/me");
      setEmployee(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setEmployee(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await employeeApi.post("/employee-portal/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setEmployee(data.employee);
    return data;
  };
  const logout = async () => {
    // AP-022.1 Sprint B · avisa o backend p/ audit (best-effort)
    try { await employeeApi.post("/employee-portal/auth/logout"); } catch (_) {}
    localStorage.removeItem(TOKEN_KEY);
    setEmployee(null);
  };

  const value = useMemo(() => ({ employee, loading, login, logout, refresh, setEmployee }),
                        [employee, loading]);
  return <EmployeeAuthContext.Provider value={value}>{children}</EmployeeAuthContext.Provider>;
}

export const useEmployeeAuth = () => useContext(EmployeeAuthContext);

export function EmployeeRoot() {
  return (
    <EmployeeAuthProvider>
      <Outlet />
    </EmployeeAuthProvider>
  );
}

export function EmployeeGuard({ children }) {
  const { employee, loading } = useEmployeeAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Carregando…</div>;
  if (!employee) return <Navigate to="/employee/login" replace state={{ from: loc }} />;
  return children;
}
